import { type AchievementFragment } from '@lingoda/monolith-graphql';
import { AchievementSlug } from '../models';

export const isAchievementActive = (achievement: AchievementFragment) => {
    const { slug, currentProgress, value } = achievement;

    return slug === AchievementSlug.ONBOARDING_CHECKLIST || currentProgress >= value;
};
